import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalJourneyListRow } from "./types";

// Open (incomplete) public tasks across all of the partner's journey
// assignments, surfaced as the top-nav "Action plan" badge. Keyed on
// portal.tasks.openCount() so the progress/snooze/proof mutation hooks that
// already invalidate that key refresh the badge for free.
export function useOpenTaskCount() {
  return useQuery<number>({
    queryKey: queryKeys.portal.tasks.openCount(),
    queryFn: async () => {
      const rows = await apiFetch<PortalJourneyListRow[]>(
        "/portal/journeys/list",
      );
      return rows.reduce(
        (sum, r) =>
          sum + Math.max(0, r.total_public_tasks - r.completed_public_tasks),
        0,
      );
    },
  });
}
